import { AfterViewInit, Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ModalComponent } from '../modal/modal-component';
import { GridColumn } from 'src/lib/tark-ng-utils/table/grid-column';
import { NgClass } from '@angular/common';
import { TableComponent } from 'src/lib/tark-ng-utils/table/table.component';

@Component({
    selector: 'pos-info-modal-with-table',
    templateUrl: './info-modal-with-table.component.html',
    styleUrls: ['./info-modal-with-table.component.scss'],
    imports: [NgClass, TableComponent]
})
export class InfoModalWithTableComponent extends ModalComponent implements AfterViewInit {

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    event.stopPropagation();
  }

  @ViewChild('confirmButton', { static: false }) confirmButtonRef: ElementRef<HTMLButtonElement>;

  public message: string = '';
  public confirmButtonText: string = 'OK';
  public rejectButtonText: string = '';
  public modalHeaderText: string = 'Info';

  public tableColumns: GridColumn[] = [];
  public tableData: any[] = [];

  /** Pass a single array – columns auto-derived from object keys */
  private _tableList: any[] = [];
  public set tableList(value: any[]) {
    this._tableList = value ?? [];
    if (this._tableList.length > 0 && this.tableColumns.length === 0) {
      this.tableColumns = Object.keys(this._tableList[0]).map(key =>
        new GridColumn({ HeaderText: this.toHeaderText(key), Field: key })
      );
    }
    if (this._tableList.length > 0 && this.tableData.length === 0) {
      this.tableData = this._tableList;
    }
  }

  constructor(modalRef: BsModalRef) {
    super(modalRef);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.confirmButtonRef?.nativeElement?.focus();
    });
  }

  get hasTableData(): boolean {
    return this.tableColumns?.length > 0 && this.tableData?.length > 0;
  }

  public onConfirm(): void {
    this.hide({ shouldConfirm: true });
  }

  public onRejectConfirm(event): void {
    this.hide({ shouldConfirm: false, event: event });
  }

  /** Converts camelCase/PascalCase key to 'Title Case' header (e.g. productName → Product Name) */
  private toHeaderText(key: string): string {
    return key
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
      .replace(/^./, s => s.toUpperCase());
  }
}
